import axios from 'axios';

// aqui a baseUrl já foi configurada na instância do axios! 
const api = axios.create({
  baseURL: process.env.REACT_APP_API,
});

export default api;
